'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultProps = {
  type: 'text',
  onChange: function onChange() {}
};

var TextInput = function (_Component) {
  (0, _inherits3.default)(TextInput, _Component);

  function TextInput() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextInput.__proto__ || (0, _getPrototypeOf2.default)(TextInput)).call.apply(_ref, [this].concat(args))), _this), _this.handleClear = function () {
      _this.input.value = '';

      _this.input.dispatchEvent(new Event('input', {
        bubbles: true
      }));

      _this.props.onChange({
        preventDefault: function preventDefault() {},
        target: _this.input,
        currentTarget: _this.input
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextInput, [{
    key: 'getInputDOM',
    value: function getInputDOM() {
      return this.input;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        className: this.classes
      }, _react2.default.createElement('input', (0, _extends3.default)({}, this.props, {
        className: 'Input-input',
        ref: function ref(c) {
          return _this2.input = c;
        }
      })), _react2.default.createElement('i', {
        className: 'Input-clear material-icons',
        onClick: this.handleClear
      }, 'clear'));
    }
  }, {
    key: 'classes',
    get: function get() {
      return (this.props.className || '') + ' Input Input--text';
    }
  }, {
    key: 'value',
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
  }]);
  return TextInput;
}(_react.Component);

TextInput.defaultProps = defaultProps;
exports.default = TextInput;